import template from 'text-loader!templates/reporting/wizard/editTitleSummary.html'
import StepView from 'views/reporting/wizard/stepView'
import I18n from 'i18n'
import 'libraries/froalaConfig'
import 'froala.colors'
import 'froala.char_counter'
import froalaButtons from 'libraries/froalaButtons'
import 'backbone.marionette'

var View = StepView.extend({
  template: template,
  className: "wizard-step rounded clearfix",
  triggers: {
    'keyup #title': 'change:title',
    'click #editable': 'click:editable'
  },
  initialize: function () {
    this.on('change:title', () => {
      var value = this.$('#title').val();
      this.model.set({title: value});
    });
    this.on('change:summary', () => {
      var value = this.$('#summary').froalaEditor('html.get');
      this.model.set({summary: value});
    });
    this.on('click:editable', () => {
      this.$('#editable').toggleClass("checked");
      var value = this.$('#editable').hasClass("checked");
      this.model.set({editable: value});
    });

    this.model.on('change:currentStep', () => {
      if (this.$('#summary').data('froala.editor')) {
        var value = this.$('#summary').froalaEditor('html.get');
        this.model.set({summary: value});
      }
    });

    StepView.prototype.initialize.call(this);
  },
  serializeData: function () {
    var report = this.model.get('report');

    return {
      title: this.model.get('title'),
      summary: this.model.get('summary'),
      editable: this.model.get('editable'),
      canChangeEditability: report.isNew() || report.get('is_owner'),
      summaryMaxLength: 5000,
      titleMaxLength: 127
    };
  },
  updateForm: function () {
    this.$('#editable').removeClass("checked");

    if (this.model.get("editable") === true) {
      this.$('#editable').addClass("checked");
    }
  },
  onRender: function () {
    var view = this;
    view.updateForm();

    if (this.$('#summary').data('froala.editor')) {
      this.$('#summary').froalaEditor('destroy');
    }
    var toolbarButtons = froalaButtons();
    this.$('#summary').froalaEditor({
      language: (I18n.locale || 'en').split("-")[0],
      key: FROALA_KEY,
      toolbarInline: true,
      editorClass: 'froala textarea textarea--xxlarge wysiwyg-summary-content',
      charCounterMax: 5000,
      heightMin: 200,
      toolbarButtons:   toolbarButtons,
      toolbarButtonsMD: toolbarButtons,
      toolbarButtonsSM: toolbarButtons,
      toolbarButtonsXS: toolbarButtons,
      shortcutsEnabled: ['bold', 'italic', 'undo', 'redo'],
      toolbarVisibleWithoutSelection: false,
      htmlAllowedTags: ['ul', 'ol', 'li', 'hr', 'h2', 'span', 'em', 'strong', 'p', 'normal', 'br', 'a', 'font'],
      htmlAllowComments: false,
      wordPasteKeepFormatting: false
    });
    var editor = this.$('#summary').data('froala.editor');
    editor.$box.css({'padding': '10px', 'font-family': 'inherit', 'border': '1px solid #ccc', 'border-radius': '5px'});
    editor.$box.find('.fr-counter').remove();
    this.$('#summary').on('froalaEditor.contentChanged', function () {
      view.trigger('change:summary');
    });
  }
});

export default View;
